/**
 * Central list of lead statuses used across the Admin panel and Team portal.
 * Keep this file as the single source of truth so drop-downs stay in sync.
 */
export const LEAD_STATUSES = [
    { value: "new", label: "New" },
    { value: "contacted", label: "Contacted" },
    { value: "call_back", label: "Call back" },
    { value: "interested", label: "Interested" },
    { value: "not_interested", label: "Not interested" },
    { value: "do_not_call", label: "Do not call" },
    { value: "lang_barrier", label: "Lang barrier" },
    { value: "converted", label: "Converted" },
    { value: "closed", label: "Closed" },
];

export const leadStatusLabel = (v) => (LEAD_STATUSES.find((s) => s.value === v)?.label || v);

// Tailwind badge classes per status — kept close to the existing palette.
export const leadStatusBadgeClass = (v) => {
    switch (v) {
        case "converted":      return "bg-emerald-100 text-emerald-700";
        case "interested":     return "bg-emerald-50 text-emerald-700";
        case "contacted":      return "bg-blue-100 text-blue-700";
        case "call_back":      return "bg-sky-100 text-sky-700";
        case "not_interested": return "bg-rose-100 text-rose-700";
        case "do_not_call":    return "bg-red-100 text-red-700";
        case "lang_barrier":   return "bg-amber-100 text-amber-800";
        case "closed":         return "bg-muted text-muted-foreground";
        default:               return "bg-primary/10 text-primary"; // new
    }
};
